<template>
    <Modal :show="true" @close="close">
        <form class="flex flex-col space-y-4" @submit.prevent="submit">
            <h3 class="text-lg font-semibold">
                {{ lang('reservations::schedule.modals.generate_slots.title') }}
            </h3>

            <fieldset
                class="px-6 py-3 -mx-6 space-y-4 border-gray-300 bg-gray-50 border-y dark:bg-zinc-800 dark:border-zinc-900"
            >
                <legend hidden>{{ lang('reservations::slots.title') }}</legend>

                <Field v-model="form.params.from" :field="{ adminComponent: 'AdminTime', name: 'Od', slug: 'from' }" />

                <Field v-model="form.params.to" :field="{ adminComponent: 'AdminTime', name: 'Do', slug: 'to' }" />

                <Field
                    v-model="form.params.interval"
                    :field="{ type: 'number', adminComponent: 'AdminNumber', name: 'Interval', slug: 'interval' }"
                />
            </fieldset>

            <fieldset class="px-4 py-2">
                <div class="flex space-x-8">
                    <div class="flex-auto text-center">
                        <Button
                            type="submit"
                            :class="{ 'opacity-75': form.processing }"
                            :loading="form.processing"
                            :disabled="form.processing"
                            dusk="form-submit"
                            color="primary"
                        >
                            {{ lang('reservations::slots.actions.generate') }}
                        </Button>
                    </div>
                </div>
            </fieldset>
        </form>
    </Modal>
</template>
<script setup lang="ts">
import { useForm } from '@inertiajs/vue3';

interface Day {
    reservable_id: number | string;
    reservable_type: string;
    date: string;
}

interface Props {
    day?: Day;
}

const props = withDefaults(defineProps<Props>(), {
    day: () => ({
        reservable_id: null,
        reservable_type: '',
        date: '',
    }),
});

const emit = defineEmits(['close', 'generated']);

const close = () => {
    emit('close');
};

const form = useForm({
    reservable_id: props.day?.reservable_id,
    reservable_type: props.day?.reservable_type,
    strategy: 'Modules\\Reservations\\Strategies\\IntervalStrategy',
    params: {
        date: props.day?.date,
        from: '08:00',
        to: '18:00',
        interval: 30,
    },
});

const submit = () => {
    form.post(route('reservations.slots.generate'), {
        preserveScroll: true,
        preserveState: true,
        forceFormData: true,
        onSuccess: () => emit('generated'),
        onStart: () => ({}),
        onFinish: () => ({}),
    });
};
</script>
